import { loadStripe } from "@stripe/stripe-js";
import { api } from "@/lib/api";

let stripePromise = null;
let cachedKey = null;

export function getStripe(key) {
  if (!stripePromise || cachedKey !== key) {
    stripePromise = loadStripe(key);
    cachedKey = key;
  }
  return stripePromise;
}

export async function fetchPaymentConfig() {
  try {
    const { data } = await api.get("/config/payments");
    return data;
  } catch {
    return { mode: "test", publishable_key: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY };
  }
}

export const stripeAppearance = {
  theme: "night",
  variables: {
    colorPrimary: "#D4AF37",
    colorBackground: "#13151A",
    colorText: "#FAF8F5",
    colorTextSecondary: "#9CA3AF",
    colorDanger: "#F87171",
    fontFamily: "Outfit, sans-serif",
    borderRadius: "10px",
  },
  rules: {
    ".Input": { border: "1px solid rgba(212,175,55,0.25)", backgroundColor: "#0B0C0E" },
    ".Input:focus": { border: "1px solid #D4AF37", boxShadow: "0 0 0 3px rgba(212,175,55,0.15)" },
    ".Label": { color: "#9CA3AF", fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.12em" },
    ".Tab": { border: "1px solid rgba(212,175,55,0.25)", backgroundColor: "#0B0C0E" },
    ".Tab--selected": { border: "1px solid #D4AF37", backgroundColor: "rgba(212,175,55,0.08)" },
  },
};
